import { Checkbox, Field } from "components/shared/form";
import React, { useState } from "react";
import { apply } from "sources/books/usersGroups";

export default function UsersGroupForm(props) {
    const [data, setData] = useState(props.data || { name: "", hiddenInPlanning: false });
    const [loading, setLoading] = useState(false);
    const handleSubmit = () => {
        setLoading(true);
        apply(data).then((res) => {
            if (res) {
                props.mergeParams();
                props.back();
            }
            setLoading(false);
        });
    };

    return (
        <div className={loading ? "loading" : ""}>
            <Field
                label="Название"
                inputProps={{ name: "name" }}
                onChange={({ name, value }) => setData({ ...data, [name]: value })}
                value={data.name}
            />
            <Checkbox
                label="Скрыта в планировании"
                inputProps={{ name: "hiddenInPlanning" }}
                onChange={({ name, value }) => setData({ ...data, [name]: value })}
                value={!!data.hiddenInPlanning}
            />
            {props.hiddenDirection && (
                <Checkbox
                    label="Скрытое направление"
                    inputProps={{ name: "hiddenDirection" }}
                    onChange={({ name, value }) => setData({ ...data, [name]: value })}
                    value={!!data.hiddenDirection}
                />
            )}
            <div className="d-flex justify-content-end">
                <div className="btn btn-sm btn-brand" onClick={handleSubmit}>
                    Сохранить
                </div>
            </div>
        </div>
    );
}
